module.exports = __webpack_public_path__ + "img/zhibo.dbf48eeb.png";